<template>
  <v-dialog width="50%" v-model="openNewTicket" persistent>
    <v-card color="light-green-lighten-4">
      <v-card-title class="ma-1">
        <v-row>
          <v-col>
            <v-chip
              class="text-h5 mx-1 text-teal"
              color="grey-lighten-4"
              variant="flat"
              label
            >
              {{ $("home.caller_info.new_ticket_title") }}
            </v-chip>
          </v-col>
          <!-- <v-spacer></v-spacer>
            <v-col class="d-flex justify-end">
              <v-btn
                @click="closeCreate"
                density="compact"
                color="grey-darken-1"
                icon="mdi-window-close"
              ></v-btn>
            </v-col> -->
        </v-row>
      </v-card-title>
      <v-container>
        <v-card>
          <!-- <input ref="input" /> -->
          <v-row
            class=""
            no-gutters
            v-for="(field, idx) in ticketingLocalFields
              ? ticketingLocalFields
              : []"
            :key="idx"
          >
            <v-col>
              <v-sheet
                class="h-100 set-border rounded-lg text-center bg-teal font-weight-bold text-uppercase align-self-center"
              >
                {{ field.labels[currentLocal] }}
                <v-tooltip
                  v-if="field.is_mandatory"
                  :text="'field is mandatory'"
                >
                  <template v-slot:activator="{ props }">
                    <span v-bind="props" class="text-pink-lighten-1">*</span>
                  </template>
                </v-tooltip>
              </v-sheet>
            </v-col>
            <v-col
              class="set-border rounded-lg text-cyan-darken-1 bg-grey-lighten-4 elevation-4 text-center pa-0"
            >
              <v-sheet
                class="bg-grey-lighten-4 text-cyan-darken-1 pa-0"
                v-if="field.type == 1"
              >
                <!-- <input ref="input" /> -->
                <v-text-field
                  hide-details
                  :ref="field.key"
                  variant="solo"
                  v-model="newTicket[field.key]"
                ></v-text-field>
              </v-sheet>
              <v-sheet
                class="bg-grey-lighten-4 text-cyan-darken-1"
                v-else-if="field.type == 2"
              >
                <v-text-field
                  hide-details
                  :ref="field.key"
                  variant="solo"
                  v-model="newTicket[field.key]"
                  type="number"
                ></v-text-field>
              </v-sheet>
              <v-sheet
                class="bg-grey-lighten-4 text-cyan-darken-1"
                v-else-if="field.type == 3"
              >
                <DatePicker
                  hide-details
                  :ref="field.key"
                  v-model="newTicket[field.key]"
                  format="yyyy-MM-dd HH:mm:ss"
                  position="center"
                  dark
                  auto-apply
                  :close-on-auto-apply="true"
                  enable-seconds
                  :placeholder="
                    $t('calls.caller_info.datetime_type_placeholder')
                  "
                  text-input
                />
              </v-sheet>
              <v-sheet
                class="bg-grey-lighten-4 text-cyan-darken-1"
                v-else-if="field.type == 4"
              >
                <v-select
                  :ref="field.key"
                  :label="field.labels[currentLocal]"
                  :items="field.list"
                  v-model="newTicket[field.key]"
                  variant="solo"
                  color="teal"
                  hide-details
                ></v-select>
              </v-sheet>
              <v-sheet
                class="bg-grey-lighten-4 text-cyan-darken-1"
                v-else-if="field.type == 5"
              >
                <v-select
                  :ref="field.key"
                  :label="field.labels[currentLocal]"
                  :items="field.list"
                  v-model="newTicket[field.key]"
                  variant="solo"
                  color="teal"
                  hide-details
                  multiple
                ></v-select>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row class="mb-2">
            <v-snackbar v-model="showSnackbar" :timeout="2000">
              {{ errorMsg }}
            </v-snackbar>
            <v-col
              ><v-btn
                class="text-uppercase w-100"
                rounded="lg"
                variant="flat"
                size="large"
                color="cyan-darken-1"
                :loading="createLocalLoading"
                @click="createNewticket"
                >{{ $t("home.call_info.open_ticket_btn") }}</v-btn
              ></v-col
            >
            <v-col
              ><v-btn
                class="text-uppercase w-100"
                rounded="lg"
                variant="flat"
                size="large"
                color="orange"
                @click="closeCreate"
                >{{ $t("calls.caller_info.cancel_btn") }}</v-btn
              ></v-col
            >
          </v-row>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  props: ["open"],
  data() {
    return {
      newTicket: {},
      createLocalLoading: false,
      showSnackbar: false,
      errorMsg: "",
    };
  },
  computed: {
    ...mapGetters([
      "ticketingLocalFields",
      "acwSettings",
      "acwStatus",
      "acwTicketing",
      "currentCall",
    ]),
    openNewTicket() {
      return this.open;
    },
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  methods: {
    ...mapMutations(["setACWStatus"]),
    ...mapActions(["SetNewTicket", "SetMessageDialog"]),
    closeCreate() {
      this.$emit("close");
    },
    async createNewticket() {
      const validate = this.isValidTicketFields();
      // console.log("My vallidate:", validate);
      if (!validate.valid) {
        this.errorMsg = validate.message;
        this.showSnackbar = true;
        this.$refs[validate.key][0].$el.focus();
        return;
      }
      this.createLocalLoading = true;
      try {
        var resp = await this.SetNewTicket({
          customer: this.currentCall?.SourceID,
          ticket: JSON.stringify(this.newTicket),
        });
        this.createLocalLoading = false;
        if (resp.success) {
          // this.newTicket = resp.info;
          console.log("My resp after set caller", resp, resp.errorcode == 0);
          this.handleACWStatus();
          this.closeCreate();
        } else {
          this.SetMessageDialog({ show: true, message: resp.message });
        }
        // console.log("My values::", this.hasCallerInfo, this.newTicket);
      } catch (err) {
        this.createLocalLoading = false;
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    handleACWStatus() {
      if (
        !this.acwSettings?.enabled ||
        !this.acwSettings?.skills?.includes(this.currentCall?.Dst) ||
        !this.acwSettings?.after_work?.includes(this.acwTicketing)
      ) {
        return;
      }
      if (this.acwStatus) {
        this.setACWStatus({
          ...this.acwStatus,
          isSet: this.acwStatus.isSet.push(this.acwTicketing),
        });
      } else {
        this.setACWStatus({
          channel: this.currentCall.Channel,
          isSet: [this.acwTicketing],
        });
      }
    },
    isValidTicketFields() {
      // console.log("My validate callerInfo", this.newTicket);
      for (const key in this.newTicket) {
        const localField = this.ticketingLocalFields.find(
          (field) => field.key == key
        );
        // console.log("My local field:", localField);
        switch (localField.type) {
          case 1:
            // console.log("My type:", 1);
            if (localField.is_mandatory && this.newTicket[key].trim() == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                key,
              };
            }
            if (
              this.newTicket[key].trim() != "" &&
              !isNaN(this.newTicket[key])
            ) {
              return {
                valid: false,
                message:
                  "field " +
                  localField.labels[this.currentLocal] +
                  " is invalid",
                key,
              };
            }
            if (this.newTicket[key].trim() == "") {
              this.newTicket[key] = "-";
            } else {
              this.newTicket[key] = this.newTicket[key].trim();
            }
            break;
          case 2:
            // console.log("My type:", 2);
            if (localField.is_mandatory && this.newTicket[key] == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),

                key,
              };
            }
            if (this.newTicket[key] != "" && isNaN(this.newTicket[key])) {
              return {
                valid: false,
                message: this.$t("home.caller_info.invalid_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                key,
              };
            }
            if (!isNaN(this.newTicket[key])) {
              this.newTicket[key] = +this.newTicket[key];
            } else if (this.this.newTicket[key].trim() == "") {
              this.newTicket[key] = "-";
            }
            break;
          case 3:
            // console.log(
            //   "My type:",
            //   3,
            //   localField.is_mandatory,
            //   this.newTicket[key],
            //   typeof this.newTicket[key]
            // );
            if (localField.is_mandatory && !this.newTicket[key]) {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),

                key,
              };
            }
            if (
              !!this.newTicket[key] &&
              !moment(this.newTicket[key]).isValid()
            ) {
              return {
                valid: false,
                message: this.$t("home.caller_info.invalid_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                key,
              };
            }
            // console.log(
            //   "My caller info 3",
            //   this.newTicket[key],
            //   typeof this.newTicket[key]
            // );
            if (
              typeof this.newTicket[key] == "string" &&
              this.newTicket[key].trim() == ""
            ) {
              this.newTicket[key] = "-";
            } else if (
              this.newTicket[key] != null &&
              this.newTicket[key] != ""
            ) {
              this.newTicket[key] = moment(this.newTicket[key])
                .format("YYYY-MM-DD HH:mm:ss")
                .toString();
            }
            break;
          case 4:
            // console.log("My type:", 4);
            if (localField.is_mandatory && this.newTicket[key].trim() == "") {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),

                key,
              };
            }
            if (this.newTicket[key].trim() == "") {
              this.newTicket[key] = "-";
            } else {
              this.newTicket[key] = this.newTicket[key].trim();
            }
            break;
          case 5:
            console.log("My type:", 5);
            if (localField.is_mandatory && this.newTicket[key].length == 0) {
              return {
                valid: false,
                message: this.$t("home.caller_info.mandatory_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),

                key,
              };
            }
            if (this.newTicket[key].includes("")) {
              return {
                valid: false,
                message: this.$t("home.caller_info.invalid_field_msg", {
                  field: localField.labels[this.currentLocal],
                }),
                key,
              };
            }
            break;
        }
      }
      return { valid: true, message: "" };
    },
  },
  mounted() {
    this.ticketingLocalFields?.forEach((localField) => {
      switch (localField.type) {
        case 1:
          this.newTicket[localField.key] = "";
          break;
        case 2:
          this.newTicket[localField.key] = "";
          break;
        case 3:
          this.newTicket[localField.key] = "";
          break;
        case 4:
          this.newTicket[localField.key] = "";
          break;
        case 5:
          this.newTicket[localField.key] = [];
          break;
      }
    });
  },
};
</script>
<style scoped>
.set-border {
  border: 2px solid #d7eaf3;
}
</style>
